import React from "react";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import profile from "../../data/profile";

function ContactBand() {
  const s = profile.socials;
  return (
    <section className="glass-card" style={{ marginTop: 30, textAlign: "center" }}>
      <h2 className="section-title" style={{ justifyContent: "center" }}>
        Let's Collaborate
      </h2>
      <p className="contactus-subhead">
        Open to freelance projects and collaborations — let's build something
        together.
      </p>

      <ul
        className="home-about-social-links"
        style={{ justifyContent: "center", marginBottom: 24 }}
      >
        <li className="social-icons">
          <a href={s.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
        </li>
        <li className="social-icons">
          <a href={s.github} target="_blank" rel="noreferrer" aria-label="GitHub">
            <AiFillGithub />
          </a>
        </li>
        <li className="social-icons">
          <a href={s.twitter} target="_blank" rel="noreferrer" aria-label="Twitter">
            <AiOutlineTwitter />
          </a>
        </li>
        <li className="social-icons">
          <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
            <AiFillInstagram />
          </a>
        </li>
      </ul>

      <Link
        to="/contactus"
        className="btn btn-primary"
        style={{ marginTop: 24 }}
      >
        Send a Message
      </Link>
    </section>
  );
}

export default ContactBand;